import React, { Component } from 'react'
//material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
//dashboard-pro
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
//components
import ReactTable from "react-table";
//bussiness
import ProtocolModal from 'global/ProtocolModal';
//css
import {dangerColor,infoColor} from "assets/jss/material-dashboard-pro-react.jsx";
import UploadOss from 'global/UploadOss'
// import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const companyProtocolStyle = {
    // ...regularFormsStyle,
    tipsText:{color:dangerColor[1]},
    tipsTextBackground:{
        backgroundColor:infoColor[6],
        border:'1px solid',
        borderColor:infoColor[1],
        padding:'5px 15px',
        borderRadius:'10px'
    }
}

function DemanderCheck(props){//表格中每一行的checkbox组件
    return(
        <FormControlLabel
            control={<Checkbox color="primary" checked={props.checked} onChange={() => props.change(props.row.id,props.row.checked,props.row.protocal)} value={props.value} />}
            label="我要合作"/>
    )
}

class CompanyProtocol extends Component {
    constructor(props){
        super(props);
        // console.log(props);
        this.state = {
            tableData:[],
            curId:'',
            modalOpen:false,
            modalContent:'',
            btnVisible:props.btnVisible,
        };
        this.handleCheck = this.handleCheck.bind(this);
        this.confirmProtocol = this.confirmProtocol.bind(this);
        this.showProtocol = this.showProtocol.bind(this);
    }

    enterStep(){
        console.log('我进来了');
    }
    componentWillReceiveProps(){ // props更新更新按钮状态
        this.setState({
            btnVisible:this.props.btnVisible,
        })
        // console.log(this.props.intentionList);
    }
    componentWillUnmount(){ // 离开时清空状态
        this.setState({
            btnVisible:false,
        })
    }
   
    handleCheck(id,checked,protocal){
        // console.log(id,checked,protocal)
        if (id && checked) {
            this.props.changeFun(id);
            return;
        }
        if (!checked) {
            // this.props.changeFun(id);
            this.setState({
                modalOpen:true,
                modalContent:protocal,
                curId:id
            });
        } else {
            this.props.changeFun(this.state.curId);
            this.setState({
                modalOpen:false,
                curId:''
            });
        }
    }

    confirmProtocol(){
        this.handleCheck(null,true);
    }

    showProtocol(protocal){
        this.setState({
            modalOpen:true,
            modalContent:protocal
        });
    }
   
    render() {
        const deleteImg = (url, del) => {
            this.props.uploadFile( url, del);
          };
          const uploadSuccess = (url, del) => {
            this.props.uploadFile(url, del); //这里的index是cartoryInfos的index
          };
        const tableColumns = [
            {Header:'采购需求方',accessor:'name',sortable:false},
            {Header:'年度采购额(亿元)',accessor:'purchaseAmount',sortable:false},
            {Header:'选择意向合作单位',accessor:'checked',sortable:false,
                Cell:prop => (
                    <DemanderCheck checked={prop.value} row={prop.original} change={this.handleCheck}/>
                )
            },
            {Header:'供应商合作协议',accessor:'id',sortable:false,
                Cell:prop => (
                    <div>
                        <Button size="sm" color="info" onClick={() => {this.showProtocol(prop.original.protocal)}}>查看协议</Button>
                        {/* {   
                            prop.original.name==='善建云'&& this.state.btnVisible? <Button size="sm" color="info">上传附件</Button>:null
                        } */}
                        {
                            prop.original.id==="15"&& this.state.btnVisible? (
                                <UploadOss
                                    btnClassName="btnClass"
                                    type={prop.value + "certification"}
                                    deleteImg={(url) => deleteImg(url, true)}
                                    fileList={this.props.intentionList}
                                    openSnackbar={this.props.openSnackbar}
                                    closeSnackbar={this.props.closeSnackbar}
                                    uploadSuccess={(url) => uploadSuccess(url,false)}
                                    />
                            ):null
                        }
                    </div>
                    
                    
                )
            },      
        ]
        const {classes} = this.props;
        return (
            <div style={{height:"calc(64vh)"}}>
                <GridContainer>
                    <GridItem xs={2} sm={2} md={2}></GridItem>
                    <GridItem xs={8} sm={8} md={8}>
                        <div className={classes.tipsTextBackground}>
                            <div>勾选多个合作方时须知：</div>
                            <div>1、其中一个合作方没有审批完成，注册资料处于<span className={classes.tipsText}>冻结</span>状态，不能修改；</div>
                            <div>2、只有全部合作方审批完成（完成指：审核通过或不通过），注册资料方可<span className={classes.tipsText}>修改</span>注册资料；</div>
                            <div>3、审核通过后，再次修改资料，会推送给所有勾选合作方，请谨慎操作。</div>
                        </div>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}></GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <ReactTable data={this.props.formObj} columns={tableColumns}
                        defaultPageSize={5}
                        pageSize={this.props.formObj.length > 0 ? this.props.formObj.length : 5}
                        className="-striped -highlight"/>
                    </GridItem>
                </GridContainer>
                <ProtocolModal curId={this.state.curId} open={this.state.modalOpen} content={this.state.modalContent} 
                    confirm={this.confirmProtocol} close={() => {this.setState({modalOpen:false})}}/>
            </div>
        )
    }
}

export default withStyles(companyProtocolStyle)(CompanyProtocol);